import {
  FETCH_INSPECTIONS_SUCCESS,
  FETCH_INSPECTION_SUCCESS,
  FETCH_WAREHOUSE_OPTIONS_SUCCESS,
  UPDATE_INSPECTION_SUCCESS,
  FETCH_CONSIGNER_OPTIONS_SUCCESS,
  SEARCH_CONSIGNER_PRODUCTS_SUCCESS, 
  FETCH_CONSIGNER_PRODUCT_SUCCESS,
  FETCH_WAREHOUSER_OPTIONS_SUCCESS,
  FETCH_WAREHOUSER_WAREHOUSE_OPTIONS_SUCCESS,
  UPDATE_INSPECTION_LOCATION_SUCCESS,
  RESET_INSPECTION_LOCATION_SUCCESS_DETAILS,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  SAVE_ITEM,
  SAVE_ITEM_SUCCESS,
  NEW_SAVE_ITEM
} from "../constants/ActionTypes";

const INIT_STATE = {
  alertMessage: "",
  showMessage: false,
  loader: true,
  noContentFoundMessage: "No inspections found",
  selectedSectionId: 1,
  filters: {
    warehouse: "ALL",
    status: "ALL",
    consigner: "ALL"
  },
  pageInfo: {
    items: [],
    page: 1,
    offset: 0,
    total: 0,
    previousPage: null,
    nextPage: null
  },
  updateLocationSuccessDetails: null,
  warehouseOptions: [],
  inspection: null,
  inspectionList: [],
  consignerOptions: [],
  productOptions: [],
  product: null,
  warehouserOptions: [],
  warehouserWarehouseOptions: [],
  savedItem: null
};

const inspectionLocationSuccessMapper = (payload) => {
  if (payload) {
    return {
      ...payload,
      id: payload?.id?.value ?? '',
      shortId: payload?.id?.value ?? '',
      itemId: payload?.itemId?.value ?? '',
      warehouseId: payload?.warehouseId?.value ?? '',
    }
  }
  
  return payload;
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_INSPECTION_SUCCESS: {
      return {
        ...state,
        loader: false,
        inspection: action.payload
      };
    }
    case FETCH_INSPECTIONS_SUCCESS: {
      return {
        ...state,
        loader: false,
        inspectionList: (action.payload.items || []),
        pageInfo: action.payload
      };
    }
    case FETCH_WAREHOUSE_OPTIONS_SUCCESS: {
      return {
        ...state,
        warehouseOptions: action.payload
      };
    }
    case UPDATE_INSPECTION_SUCCESS: {
      const updatedId = action.payload.id;
      const list = state.inspectionList.map(inspection => {
        if (inspection.id === updatedId) {
          return action.payload;
        } else {
          return inspection;
        }
      });
      return {
        ...state,
        alertMessage: "Inspection updated successfully",
        showMessage: true,
        inspectionList: list
      };
    }
    case FETCH_CONSIGNER_OPTIONS_SUCCESS: {
      return {
        ...state,
        loader: false,
        consignerOptions: action.payload
      };
    }
    case SEARCH_CONSIGNER_PRODUCTS_SUCCESS: {
      return {
        ...state,
        loader: false,
        productOptions: action.payload
      };
    }
    case FETCH_CONSIGNER_PRODUCT_SUCCESS: {
      return {
        ...state,
        product: action.payload
      }
    }
    case FETCH_WAREHOUSER_OPTIONS_SUCCESS: {
      return {
        ...state,
        loader: false,
        warehouserOptions: action.payload || []
      };
    }
    case FETCH_WAREHOUSER_WAREHOUSE_OPTIONS_SUCCESS: {
      return {
        ...state,
        loader: false,
        warehouserWarehouseOptions: action.payload || []
      };
    }
    case UPDATE_INSPECTION_LOCATION_SUCCESS: {
      return {
        ...state,
        updateLocationSuccessDetails: inspectionLocationSuccessMapper(action.payload),
        loader: false,
      };
    }
    case RESET_INSPECTION_LOCATION_SUCCESS_DETAILS: {
      return {
        ...state,
        updateLocationSuccessDetails: INIT_STATE.updateLocationSuccessDetails,
      };
    }
    case ON_SHOW_LOADER: {
      return {
          ...state,
          loader: true
      }
    }
    case ON_HIDE_LOADER: {
        return {
            ...state,
            loader: true
          }
    }

    case SAVE_ITEM: {
      return {
        ...state,
        loader: true
      }
    }
    case SAVE_ITEM_SUCCESS: {
      return {
        ...state,
        loader: false,
        savedItem: action.payload
      }
    }
    case NEW_SAVE_ITEM: {
      return {
        ...state,
        savedItem: null
      }
    }

    default:
      return state;
  }
};
